"use es6";

export function isPromise(value) {
  return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}